import styled, { css } from 'styled-components';

const Wrap = styled.div`
    display: flex;
    max-height: 80px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    background: ${({theme}) => theme.colors.Background};
    box-shadow: 0px -7px 15px rgba(0, 0, 0, 0.13);
    transition: all 0.3s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ isHidden }) => isHidden && 'translateY(100%)'};
    > div {
        margin-right: ${({ theme }) => theme.spacers.L};
    }
`;

const TextWrap = styled.div`
    margin-right: 32px;
`;

const Prices = styled.span`
    display: flex;
    align-items: center;
    > * + * {
        margin-left: 8px;
    }
`;

const OldPrice = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({theme}) => theme.colors.Foreground};
    text-decoration: line-through;
`;

const Price = styled.h2`
    ${({ theme }) => theme.typography.Subheadline};
    color: ${({ theme }) => theme.colors.Foreground};
    ${({ withOldPrice, theme }) => withOldPrice
        && css`
            color: ${theme.colors.Color1};
            &::before {
                content: '';
            }
        `}
`;

const PriceSuffix = styled.h4`
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors['Level 4']};
    max-width: 162px;
`;

const Cta = styled.button`
    min-height: 48px;
    color: white;
    background: ${({theme}) => theme.colors.Color1};
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    flex: 1;
`;

const CtaText = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline}
`;

export {
    Wrap,
    TextWrap,
    Prices,
    OldPrice,
    Price,
    Cta,
    PriceSuffix,
    CtaText,
};
